import { createSlice } from "@reduxjs/toolkit";

import { getAttributeList, addAttributeList, updateAttributeList, deleteAttributeList, getAttributeSearch } from "./thunk";

export const initialState = {
    attributeList: {
        content: []
    },
    errors: {}
};

const AttributeSlice = createSlice({
    name: 'Attribute',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getAttributeList.fulfilled, (state: any, action: any) => {
            state.attributeList = action.payload;
        });
        builder.addCase(getAttributeList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getAttributeSearch.fulfilled, (state: any, action: any) => {
            state.attributeList = action.payload;
        });
        builder.addCase(getAttributeSearch.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addAttributeList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.attributeList.content.unshift(action.payload);
        });
        builder.addCase(addAttributeList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateAttributeList.fulfilled, (state: any, action: any) => {
            state.attributeList.content = state.attributeList.content.map((category: any) =>
                category.id === action.payload.id
                    ? { ...category, ...action.payload }
                    : category
            );
        });

        builder.addCase(updateAttributeList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteAttributeList.fulfilled, (state: any, action: any) => {
            state.attributeList.content = state.attributeList.content.filter(
                (attributeList: any) => attributeList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteAttributeList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default AttributeSlice.reducer;